export const enum FerryUpsellType {
  Ticket = 'ticket',
  Vehicle = 'vehicle',
}

export interface TokensForReplacement {
  oldToken: string;
  newToken: string;
}
